<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <v-btn icon to="/home">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>Delivery or Pickup</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon to="/delivery-form">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="list-of-content" v-if="items.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in items">
          <v-list-item :key="index">
            <v-list-item-content>
              <v-list-item-title class="list-of-content__title" v-html="item.desc_estatus_proceso"></v-list-item-title>
              <v-list-item-subtitle v-html="item.content"></v-list-item-subtitle>

              <table class="list-of-content__details">
                <tr>
                  <th>Address</th>
                  <td>{{item.direccion_entrega}}</td>
                </tr>
                <tr>
                  <th>Request code</th>
                  <td>{{item.codigo}}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td>{{item.telefono1}}</td>
                </tr>
                <tr>
                  <th>Date</th>
                  <td>{{item.fec_creacion}}</td>
                </tr>
              </table>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>

    <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          {{language.you_have_no_data_available}}
        </div>
      </div>
      <v-progress-circular :size="90" color="blue" indeterminate class="loading-center" v-else></v-progress-circular>
    </div>
  </v-container>
</template>


<script>
// import Helpers from '../utils/helpers'
import Server from "../utils/server";
var files = [];
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      (newValue) => {
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }
  },
  data() {
    return {
      clipped: false,
      items: [],
      currentUser: undefined,
      noData: false,
      loading: false,
      guia: null,
      idpack: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
  },
  methods: {
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      console.log(this.currentUser);
      this.$http.post(Server.DeliveryRequest, formData).then(
        (response) => {
          console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.items = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    },
    pickFile(guia, idpack) {
      window.MobileApi.uploadInvoice(
        Server.uploadInvoicePrealerta,
        guia,
        idpack,
        this.currentUser.userName,
        this.getPacks
      );
    },
    onFilePicked() {
      this.loading = true;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageFile = files[0]; // this is an image file that can be sent to server...
          var formData = new FormData();
          formData.append("text1", this.currentUser.userName);
          formData.append("text3", this.currentUser.pushId);
          formData.append("device", window.MobileApi.device);
          formData.append("PARAMETRO2", this.guia);
          formData.append("PARAMETRO1", this.idpack);
          formData.append("photo", this.imageFile);
          this.$http.post(Server.uploadInvoice, formData).then(
            // response => {
            () => {
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        });
      }
    },
  },
  name: "App",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
